export const SET_USER = 'SET_USER'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION'
export default {
  [SET_USER] (state, payload) {
    state.user = payload
  },
  [SET_LOCATIONS] (state, payload) {
    state.locationsList = payload
  },
  [SET_SELECTED_LOCATION] (state, payload) {
    state.selectedLocations.push(payload)
  }
}
